import Vue from "vue";
import Vuex from "vuex";
import globalStore from "./modules/global";
import defaultStore from "./modules/default";
import wechatStore from "./modules/wechat";

Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        global:globalStore,
        default:defaultStore,
        wechat:wechatStore,
    }
});
